import axios from '../helpers/axios'

const buildQuery = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    query.append(key, String(value))
  })

  const suffix = query.toString()
  return suffix ? `?${suffix}` : ''
}

export const fetchPaymentsOverview = async (params = {}) => {
  const res = await axios.get(`/billing/admin/overview${buildQuery(params)}`)
  return res.data?.overview || null
}

export const fetchPayments = async (params = {}) => {
  const res = await axios.get(`/billing/admin/payments${buildQuery(params)}`)
  return res.data || { payments: [], totalAll: 0, totalPages: 0 }
}

export const fetchPaymentDetails = async (paymentId) => {
  const res = await axios.get(`/billing/admin/payments/${paymentId}`)
  return res.data || null
}

export const reviewPayment = async (paymentId, payload) => {
  const res = await axios.patch(`/billing/admin/payments/${paymentId}/review`, payload)
  return res.data?.payment || null
}

export const fetchTransactions = async (params = {}) => {
  const res = await axios.get(`/billing/transactions/all${buildQuery(params)}`)
  return res.data || { transactions: [], totalAll: 0, totalPages: 0 }
}

export const fetchDigitalCatalog = async (params = {}) => {
  const res = await axios.get(`/billing/admin/digital-catalog${buildQuery(params)}`)
  return res.data || { items: [], totalAll: 0, totalPages: 0 }
}

export const saveDigitalOffer = async (productId, payload) => {
  const res = await axios.put(`/billing/admin/digital-offer/product/${productId}`, payload)
  return res.data?.offer || null
}

export const fetchLicenses = async (params = {}) => {
  const res = await axios.get(`/billing/admin/licenses${buildQuery(params)}`)
  return res.data || { licenses: [], totalAll: 0, totalPages: 0 }
}

export const grantLicense = async (payload) => {
  const res = await axios.post('/billing/admin/licenses/grant', payload)
  return res.data || null
}

export const updateLicenseStatus = async (licenseId, payload) => {
  const res = await axios.patch(`/billing/admin/licenses/${licenseId}/status`, payload)
  return res.data?.license || null
}

export const getApiErrorMessage = (error, fallback = 'Ошибка запроса') => (
  error?.response?.data?.error
  || error?.response?.data?.message
  || error?.message
  || fallback
)


export const fetchBillingSettings = async () => {
  const res = await axios.get('/billing/admin/settings')
  return res.data?.settings || null
}

export const saveBillingSettings = async (payload) => {
  const res = await axios.put('/billing/admin/settings', payload)
  return res.data?.settings || null
}

export const updateOfficeCreditLimit = async (officeId, creditLimit) => {
  const res = await axios.patch(`/billing/admin/office/${officeId}/credit-limit`, { creditLimit })
  return res.data || null
}
